<svelte:options customElement={{ tag: "bt-add-external-link-button", shadow: "none", }} />

<script lang='ts'>
  import { eventBus } from '$shared/lib/eventBus';
  export let curationId: number;
  export let addModalText;
  export let addSectionText: string = "Link";
  export let addToCurationText;
  export let contentTypeText;
  export let descriptionLabel;
  export let dropdownArticle;
  export let dropdownAudio;
  export let dropdownLink;
  export let dropdownSurvey;
  export let dropdownText;
  export let dropdownVideo;
  export let editModalText;
  export let estimatedDurationLabel;
  export let optionalText;
  export let linkText;
  export let pasteUrlHereText;
  export let requiredText;
  export let saveChangesText;
  export let titleLabel;
  export let titlePlaceholder;
  export let validUrlText;

  const handleClick = () =>  {
    eventBus.emit('external-link-opened', { curationId});
  }
</script>

<bt-modal-toggle
  opensModal={true}
  modalToToggle="externalLinkModal"
  modalData={btoa(JSON.stringify({ 
    addModalText,
    addToCurationText,
    contentTypeText,
    curationId,
    descriptionLabel,
    dropdownArticle,
    dropdownAudio,
    dropdownLink,
    dropdownSurvey,
    dropdownText,
    dropdownVideo,
    editModalText,
    estimatedDurationLabel,
    linkText,
    optionalText,
    pasteUrlHereText,
    requiredText,
    saveChangesText,
    titleLabel,
    titlePlaceholder,
    validUrlText,
  }))}
  >
  <button class="font-normal text-base text-black hover:text-neutral-500" on:click={handleClick}>
    <p>{addSectionText}</p>
  </button>
</bt-modal-toggle>